import React from 'react'
import { Link } from 'react-router-dom'
import { Space, Typography } from 'antd'
import { get, groupBy, isNil, keys, map } from 'lodash'
import PropTypes from 'prop-types'

import { StyledVerticalSpace } from '../../../common/components/styled'

import IngredientConflictingErrors from './ingredient-conflicting-errors'

const IngredientReplaceConflictingErrors = ({ errors }) => {
  const errorsGroupedByType = groupBy(errors, 'errorType')

  return map(keys(errorsGroupedByType), (errorType, errorTypeIndex) => {
    const errorsOfType = get(errorsGroupedByType, errorType)

    if (errorType === 'NO_MULTIPLE_ALLOWED') {
      return (
        <Typography.Paragraph key={errorTypeIndex}>
          <StyledVerticalSpace>
            <Typography.Text strong>
              No multiple replacements allowed on:
            </Typography.Text>
            {map(errorsOfType, (error, index) => {
              if (!isNil(error.dietName)) {
                return (
                  <Space key={index}>
                    <Link to={`/ingredients/${error.ingredientId}`}>
                      {error.ingredientName}
                    </Link>
                    <Typography.Text>On Diet: {error.dietName}</Typography.Text>
                    <Typography.Text>
                      Ingredient: {error.alternativeIngredientName}
                    </Typography.Text>
                  </Space>
                )
              }

              if (!isNil(error.dishTypeName)) {
                return (
                  <Space key={index}>
                    <Link to={`/dish-types/${error.dishTypeId}`}>
                      {error.dishTypeName}
                    </Link>
                    <Typography.Text>
                      On Replaced Ingredient: {error.ingredientName}
                    </Typography.Text>
                    <Typography.Text>
                      Replacement Ingredient: {error.alternativeIngredientName}
                    </Typography.Text>
                  </Space>
                )
              }

              return (
                <Space key={index}>
                  <Link to={`/ingredients/special-cases/${error.caseId}`}>
                    {error.caseName}
                  </Link>
                  <Typography.Text>On target_ingredient</Typography.Text>
                </Space>
              )
            })}
          </StyledVerticalSpace>
        </Typography.Paragraph>
      )
    }

    if (errorType === 'CONFLICTING_ALTERNATIVES_OVERRIDES') {
      return <IngredientConflictingErrors errors={errorsOfType} />
    }

    // if (errorType === 'CONFLICTING_DISH_TYPE_REPLACEMENTS') {
    return map(errors, (error, errorTypeIndex) => (
      <Typography.Paragraph key={errorTypeIndex}>
        <Space>
          <Typography.Text strong>{error.message}</Typography.Text>
          <Link to={`/dish-types/${error.dishTypeId}`}>
            {error.dishTypeName}
          </Link>
        </Space>
      </Typography.Paragraph>
    ))
  })
}

IngredientReplaceConflictingErrors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default IngredientReplaceConflictingErrors
